<template>
    <div class="tracking-chart">
      <div class="chart-container" style="position: relative; height:40vh; width:100%">
        <canvas class="chart" ref="chart"></canvas>
      </div>
    </div>
</template>
<script>
import elementResizeDetector from 'element-resize-detector'
import Chartjs from 'chart.js'

export default {
  props: {
    leadsCount: {
      type: Object
    },
    dateFormat: {
      type: String,
      default: "DD/MM"
    },
    startDate: String,
    endDate: String,
  },
  data() {
    return{
      stats: [],
      labels: [],
      precision: 'day'
    }
  },
  mounted() {
    if(this.leadsCount){
      this.setupPrecision()
      this.processTrackings(this.leadsCount, this.precision)
      this.drawChart()
    }
    let erd = elementResizeDetector()
    erd.listenTo(document.querySelector(".chart"), (element) => {
    })
  },
  methods: {
    date(date){
      return moment(date).fromNow()
    },
    setupPrecision(){
      let start_date = new moment(this.startDate)
      let end_date = new moment(this.endDate)

      let differenceDay = end_date.diff(start_date, 'days')

      if(differenceDay <= 3){
        this.precision = "hour"
      }else if(differenceDay <= 80){
        this.precision = "day"
      }else{
        this.precision = "week"
      }
    },
    processTrackings(trackings, breakdown){
      this.labels = []
      this.stats = []
      if(trackings){
        let start_date = new moment(this.startDate)
        let end_date = new moment(this.endDate)

        for(let i = start_date; i <= end_date; i.add(1, breakdown + 's')){
          this.labels.push(i.format("hh:mm HH m M MM"))
          let result
          Object.keys(trackings).map(function(objectKey, index) {
            let count = trackings[objectKey]
            let date = moment(objectKey)
            if(date.isSame(i, breakdown)){
              result = count
              return
            }
          });
          if(result){
            this.stats.push({y: result, x: i.format() })
          }else{
            this.stats.push({y: 0, x: i.format() })
          }
        }
      }
    },
    drawChart(){
      let data = []
      this.stats.forEach(tracking=>{
        let formatted = {x: new Date(tracking.time), y: 1}
        data.push(formatted)
      })
      let options = {
        tooltips: {
          enabled: false
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: "time",
            time: {
              unit: 'day',
            } }],
          axesY: [{
            ticks: {
              scaleMinSpace: 50,
              stepSize: 1,
              min: 0,
              autoSkip: true
            }
          }]
        },
        maintainAspectRatio: false,
        padding: {
          left: 0, right: 0, top: 0, bottom: 0
        }
      }

      var chart = new Chart(this.$refs.chart.getContext('2d'), {
        type: 'line',
        data: {datasets: [{
          data: this.stats,
          lineTension: 0.2,
          fill: false,
          borderColor: '#1B88FD',
        }]},
        options
      })
    }
  },
  watch: {
    trackings(){
      if(this.leadsCount){
        this.setupPrecision()
        this.processTrackings(this.leadsCount, this.precision)
        this.drawChart()
      }
    }
  }
}
</script>
<style lang="scss">
.ct-label{
  display: inline-block;
  font-size: 12px;
  &.ct-vertical{
    text-align:right;
    margin-top: 15px;
  }
  &.ct-horizontal{
    // padding-top: 15px;
    margin-left: -15px;
  }
}
.ct-grid{
  stroke: lighten($color-2,70);
}
.ct-point {
  stroke: $color-1;
  stroke-width: 6px;
  stroke-linecap: round;
}
.ct-line{
  stroke: lighten($color-1,20);
  stroke-width: 2px;
  fill: transparent;
}
</style>



// WEBPACK FOOTER //
// LeadsCountChart.vue?4728ad94